////////////////////////////////////
//  Detail Slider
////////////////////////////////////

if ($('#js-slideshow').length) {
  
  if ($('#js-slideshow li').length > 1) {
      $('.slideshow#js-slideshow').each(function(index) {
        $(this).addClass('js-slideshow' + index); $(this).find('li').addClass('js-slide' + index);
      });

    $('.slideshow#js-slideshow').each(function(index) {
      sliderControl( $( '.js-slideshow' + index ), index );
    });
  }

  function sliderControl($sliderEl) {

   var $sliderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
   //変数の設定
   var $sliderWrap = $sliderEl,
       $slider = $sliderWrap.find('.slideshow-slides'),
       $slides = $slider.find('.js-slide' + $sliderId),
       sliderWidth = $slides.width(),
       slideLength = $slides.length,
       $indicator = $sliderWrap.next('.slideshow-indicator'),
       interval = 6000; //自動スライダーの秒数
   var currentIndex = 0,
       timer = '',
       $item = '',
       $slide = '',
       dragFlg = false,
       currentIndexPrevClickIndicator = null,
       posX,
       //マウスの位置
       imgPosX,
       drugDis; //ドラッグ距離;
       console.log($slides); //インジケーターの生成
   function addIndicator() {
     var indicatorHTML = '<a class=\"js-item' + $sliderId + '\"></a>';
     for (var i = 0; i < slideLength; i++) {
       $indicator.append(indicatorHTML);
     }
     $item = $('.js-item' + $sliderId);
     $slide = $('.js-slide' + $sliderId);
     $item.eq(currentIndex).addClass('active');
     $slide.eq(currentIndex).addClass('active');
   } //現在のスライド位置をインジケーターに表示
   function updateNav() {
     $item.removeClass('active');
     $slide.removeClass('active');
     $slide.removeClass('prev');
     $item.eq(currentIndex).addClass('active');
     $slide.eq(currentIndex).addClass('active');
     if (currentIndexPrevClickIndicator !== null) {
       $slide.eq(currentIndexPrevClickIndicator).addClass('prev');
       currentIndexPrevClickIndicator = null;
     } else {
       $slide.eq(currentIndex - 1).addClass('prev');
     }
   }
   //インジケータークリック処理
   function goSomeWhere() {
     if (!$slider.is(':animated')) {
       currentIndexPrevClickIndicator = currentIndex;
       currentIndex = $(this).index();
       stopTimer();
       startTimer();
       changeSlide();
     }
   }
   //セレクトボックス変更
   function selectChange(currentIndex2) {
       //currentIndexPrevClickIndicator = currentIndex2;
       currentIndex = currentIndex2;
       stopTimer();
       startTimer();
       changeSlide();
   }
   //スライドアニメーション
   function changeSlide() {
     if (currentIndex === slideLength) {
       currentIndex = 0;
     } else if (currentIndex === -1) {
       currentIndex = slideLength - 1;
     }
     //インディケーターを更新
     updateNav();
   }
   //prevボタンの処理
   function prevSlide() {
     if (!$slider.is(':animated')) {
       currentIndex--;
       changeSlide();
     }
   } //nextボタンの処理
   function nextSlide() {
     if (!$slider.is(':animated')) {
       currentIndex++;
       changeSlide();
     }
   } //スライダークリック時
   function clickSlider(evt1) {
     //ドラッグ中にする
     dragFlg = true; //クリック位置取得
     posX = evt1.screenX; //要素の位置も取得
     posX = evt1.pageX; //要素の位置も取得
     imgPosX = $slider.position();
   } //スライダークリック解除時
   function leaveSlider() {
     if (dragFlg === true) {
       //ドラッグ量が画像の半分以上なら、次スライドへ移動
       if (drugDis == 0 || drugDis < -(sliderWidth / 4)) {
         currentIndexPrevClickIndicator = currentIndex;
         stopTimer();
         startTimer();
         nextSlide();
       } else if (drugDis > sliderWidth / 4) {
         //半分以下なら元のスライドに戻す
         currentIndexPrevClickIndicator = currentIndex;
         stopTimer();
         startTimer();
         prevSlide();
       } else {
         //半分以下なら元のスライドに戻す
         changeSlide();
       } //フラグリセット
       dragFlg = false;
     }
   } //スライダー移動時
   function moveSlider(evt2) {
     if (dragFlg === true) {
       evt2.preventDefault(); //ドラッグ距離を保存
       drugDis = evt2.screenX - posX;
   drugDis = evt2.pageX - posX;
     }
   } //タイマースタート
   function startTimer() {
     timer = setInterval(nextSlide, interval);
   }
   function stopTimer() {
     clearInterval(timer);
   } //カルーセルイベント一覧
   function setEvent() {
     var clickEvent=((window.ontouchstart!==null)?'mousedown':'touchstart');var moveEvent=((window.ontouchmove!==null)?'mousemove':'touchmove');var endEvent=((window.ontouchend!==null)?'mouseup':'touchend'); $(window).on(moveEvent, moveSlider);
     $(window).on(endEvent, leaveSlider);
     $slider.on(clickEvent, clickSlider);
     $item.on(clickEvent, goSomeWhere);
   }
   addIndicator(); // グレーのmaskが消えてからタイマースタート
   setTimeout(function () {
     startTimer();
   }, 1000);
   setEvent();

  }
   
}